// extracted by mini-css-extract-plugin
module.exports = {"i2o2jy6":"i2o2jy6"};